// removed by extract-text-webpack-plugin
module.exports = {"theme":"#1890ff"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/element-variables.scss
// module id = VUEL
// module chunks = 13